import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import ReactLoading from 'react-loading';
import { Box, Typography, CircularProgress, Grid, ImageList, ImageListItem, ImageListItemBar, useMediaQuery, useTheme } from "@mui/material"
import VideocamIcon from '@mui/icons-material/Videocam';
import AudioFileIcon from '@mui/icons-material/AudioFile';
import TouchAppIcon from '@mui/icons-material/TouchApp';

import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import { GetProjectLink } from './../../../../axios/ApiProvider';
import { getPopularPexelsData, getPopularPixaBayStockData, getFreeSoundSearch } from "../../../../axios/ApiProvider";
import './stocks.scss';

import pexelsVideoLogo from "../../../../assets/image/Logos/pexelVideo.png";
import pixabayVideoLogo from "../../../../assets/image/Logos/pixabayVideo.png";
import freeSoundLogo from "../../../../assets/image/Logos/freeSound.png";

let mobileScreenDetectCols = 4
if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(navigator.userAgent || navigator.vendor || window.opera) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test((navigator.userAgent || navigator.vendor || window.opera).substr(0, 4))) {
  mobileScreenDetectCols = 1;
}
const EDIT_FRONTEND_URL = process.env.REACT_APP_BASE_FRONTEND_EDITOR_URL
const BASE_BACKEND_URL = process.env.REACT_APP_BASE_BACKEND_URL

export const Stocks = () => {

  const [pexelsVideos, setPexelsVideos] = useState([]);
  const [isLoadingPexels, setIsLoadingPexels] = useState(true);
  const [pixabayVideos, setPixabayVideos] = useState([]);
  const [isLoadingPixabay, setIsLoadingPixabay] = useState(true);
  const [freeSoundAudios, setFreeSoundAudios] = useState([]);
  const [isLoadingFreeSound, setIsLoadingFreeSound] = useState(true);

  const [isHoverId, setIsHoverId] = useState(null);

  const [previewAudioId, setPreviewAudioId] = useState(null);
  const previewAudioEl = useRef(null);


  const theme = useTheme();
  const lg = useMediaQuery(theme.breakpoints.up("lg"));
  const md = useMediaQuery(theme.breakpoints.up("md"));
  const sm = useMediaQuery(theme.breakpoints.up("sm"));
  let columns = 2;
  if (lg) columns = 4;
  else if (md) columns = 3;
  else if (sm) columns = 2;

  useEffect(() => {
    //loadPexelsVideos();
    loadPixabayVideos();
    loadFreeSoundAudios();
  }, [])

  const loadPexelsVideos = async () => {
    setIsLoadingPexels(true);
    const pexelsData = await getPopularPexelsData(1);
    if (pexelsData.state !== "success") return;
    console.log('loadedData', pexelsData);
    setPexelsVideos(pexelsData.data.videos);
    setIsLoadingPexels(false);
  }

  const loadPixabayVideos = async () => {
    setIsLoadingPixabay(true);
    const pixabayData = await getPopularPixaBayStockData(1);
    if (pixabayData.state !== 'success') {
      setIsLoadingPixabay(false);
      return;
    }
    console.log(pixabayData);
    setPixabayVideos(pixabayData.data.hits)
    setIsLoadingPixabay(false);
  }

  const loadFreeSoundAudios = async () => {
    setIsLoadingFreeSound(true);
    const freeSoundData = await getFreeSoundSearch();
    if (freeSoundData.state !== 'success') {
      setIsLoadingFreeSound(false);
      return;
    }
    console.log('freeSoundData', freeSoundData);
    setFreeSoundAudios(freeSoundData.data.results)
    setIsLoadingFreeSound(false);
  }

  useEffect(() => {
    if (previewAudioEl.current) {
      previewAudioEl.current.addEventListener('ended', previewEnded);
    }

    return () => {
      if (previewAudioEl.current) {
        previewAudioEl.current.removeEventListener('ended', previewEnded);
      }
    };
  }, []);


  const previewEnded = (e) => {
    setPreviewAudioId(null);
  }
  const handlePreviewAudioPlay = (stockItem) => {
    setPreviewAudioId(stockItem.id);
    previewAudioEl.current.src = stockItem.previews['preview-hq-mp3'];
    previewAudioEl.current.play();
  
  }
  const handlePreviewAudioPause = (stockItem) => {
    setPreviewAudioId(null);
    previewAudioEl.current.pause();
  }
  const onClickStockContent = async (stockData, stockType) => {
    let result = await GetProjectLink();
    if (!result || result.state == 'error') window.toastr.error(result.data.message);
    else if (!!Object.keys(result.data)[0]) {
      window.location.href = `${EDIT_FRONTEND_URL}/${Object.keys(result.data)[0]}?from=stockContent&stockType=${stockType}&stockId=${stockData.id}`
    }
  }
  return (
    <Box className="custom-projects-wrapper">

      <Box className="custom-projects-contents-section">
        <h3 className="text-start text-[30px] flex items-center"> <img style={{ height: "30px" }} className="mr-2" src={pixabayVideoLogo} /><img style={{ height: "30px" }} className="mr-2" src={pexelsVideoLogo} /></h3>
        <Box className="projects-container" sx={{ overflow: "hidden" }}>
          <Grid container sx={{ overflow: "auto", position: "relative", height: "700px" }}>
            <Grid item xs={12} sx={{ position: "relative", maxHeight: "700px" }}>
              <ImageList variant="masonry" cols={columns} gap={8} >
                {pixabayVideos.map((pixabayItem, index) => (
                  <ImageListItem key={index}
                    onClick={() => {onClickStockContent(pixabayItem, 'pixabayVideo')}}
                    onMouseOver={() => { if (isHoverId != `pixabay_${pixabayItem.id}`) { setIsHoverId(`pixabay_${pixabayItem.id}`) } }}
                    onMouseLeave={() => { setIsHoverId(null) }}
                    sx={{cursor: 'pointer'}}
                  >
                    <img
                      src={`${pixabayItem.videos.tiny.thumbnail}`}
                      alt={pixabayItem.id}
                      loading="lazy"
                      style={{
                        minWidth: "150px",
                        minHeight: "100px",
                        width: '100%',
                        height: '100%',
                        flexGrow: "unset",
                        opacity: 0,
                        transition: "opacity 0.5s ease-in-out",
                      }}
                      onLoad={(e) => e.target.style.opacity = 1}
                    />
                    {isHoverId == `pixabay_${pixabayItem.id}` &&
                      <video
                        className='stockPreview-video'
                        src={pixabayItem.videos.tiny.url}
                        loop
                        autoPlay
                        style={{
                          top: '0px',
                          left: '0px',
                          position: "absolute",
                          minWidth: "150px",
                          minHeight: "100px",
                          flexGrow: "unset",
                          width: "100%",
                          height: "100%",
                        }}
                        muted></video>
                    }
                    <ImageListItemBar
                      subtitle={<><VideocamIcon />{pixabayItem.videos.large.width} x {pixabayItem.videos.large.height}</>}
                    />
                  </ImageListItem>
                ))}
              </ImageList>
              {isLoadingPixabay && <Box sx={{ position: "absolute", top: 0, background: "rgba(0,0,0,0)", display: "flex", zIndex: 100000, flexDirection: "column", justifyContent: "center", height: "300px", width: "100%" }}>
                <Box sx={{ display: 'flex', position: "absolute", justifyContent: "center", width: "100%" }}>
                  <CircularProgress />
                </Box>
              </Box>}
            </Grid>
          </Grid>
        </Box>
        <br></br>
        {/* <h1 className="text-start text-[30px] flex items-center"><img style={{height: "30px"}} className="mr-2" src={pexelsVideoLogo}/><Typography component='span'>Pexels Stock</Typography></h1>
        <Box className="projects-container" sx={{overflow: "hidden"}}>
          <Grid container spacing={2}  sx={{overflow: "auto", position: "relative", height: "300px"}}>
            <Grid item xs={12}  sx={{position: "relative", maxHeight: "300px"}}>
              <ImageList variant="masonry" cols={mobileScreenDetectCols} gap={8} rowHeight={100}>
              {pexelsVideos.map((pexelItem, index) =>(
                <ImageListItem key={index}
                onClick={() => {onClickStockContent(pexelItem, 'pexelVideo')}}
                onMouseOver={() => {if(isHoverId != `pexel_${pexelItem.id}`){ setIsHoverId(`pexel_${pexelItem.id}`); } console.log('onMuseOver')}}
                onMouseLeave={() => {setIsHoverId(null); console.log('onMuseLeave')}}
                >
                  <img
                    src={`${pexelItem.image}`}
                    alt={pexelItem.id}  
                    loading="lazy"
                    style={{
                      minWidth: "184px",
                      minHeight: "103px",
                      flexGrow: "unset"
                    }}
                  />
                  {isHoverId == `pexel_${pexelItem.id}` && 
                    <video className='stockPreview-video' src={pexelItem.video_files[0].link} loop autoPlay style={{
                        top: '0px',
                        position: "absolute",
                        minWidth: "184px",
                        minHeight: "103px",
                        flexGrow: "unset"
                      }}></video>
                    }
                  <ImageListItemBar
                    subtitle={<><VideocamIcon />{pexelItem.width} X {pexelItem.height}</>}
                  />
                </ImageListItem>
              ))}
              </ImageList>
              {isLoadingPexels && <Box sx={{position: "absolute", top: 0,  background: "rgba(0,0,0,0)", display: "flex", zIndex: 100000, flexDirection: "column", justifyContent: "center", height: "300px", width: "100%"}}>
                <Box sx={{ display: 'flex', position: "absolute", justifyContent: "center", width: "100%" }}>
                  <CircularProgress />
                </Box>
              </Box>}
            </Grid>
          </Grid>
        </Box>
        <br></br> */}
        <audio className='freeSound-preview' ref={previewAudioEl} controls ></audio>
        <h1 className="text-start text-[30px] flex items-center"><img style={{ height: "30px" }} className="mr-2" src={freeSoundLogo} /><Typography component='span'>FreeSound Stock</Typography></h1>
        <Box className="projects-container" sx={{ overflow: "hidden" }}>
          <Grid container spacing={2} sx={{ overflow: "auto", position: "relative", height: "700px" }}>
            <Grid item xs={12} sx={{ position: "relative", maxHeight: "700px" }}>
              <ImageList variant="masonry" cols={columns} gap={8} rowHeight={150}>
              {freeSoundAudios.map((freesoundItem, index) =>(
                <ImageListItem key={index}
                >
                  <img
                    onClick={() => {onClickStockContent(freesoundItem, 'freeSound')}}
                    src={`${freesoundItem.images['waveform_l']}`}
                    alt={freesoundItem.id}  
                    loading="lazy"
                    style={{
                      minWidth: "150px",
                      minHeight: "100px",
                      flexGrow: "unset",
                      cursor: 'pointer'
                    }}
                  />
                  <ImageListItemBar
                  sx={{zIndex: '99999'}}
                    subtitle={<>
                      {previewAudioId == freesoundItem.id && 
                        <PauseCircleOutlineIcon sx={{cursor: 'pointer', fontSize: '32px'}} onClick={() => {handlePreviewAudioPause(freesoundItem)}}/>
                      }
                      {previewAudioId != freesoundItem.id && 
                        <PlayCircleOutlineIcon  sx={{cursor: 'pointer', fontSize: '32px'}}  onClick={() => {handlePreviewAudioPlay(freesoundItem)}}/>
                      }
                     <AudioFileIcon sx={{fontSize: '32px'}}/>{freesoundItem.name}</>}
                  />
                </ImageListItem>
              ))}
              </ImageList>
              {isLoadingFreeSound && <Box sx={{ position: "absolute", top: 0, background: "rgba(0,0,0,0)", display: "flex", zIndex: 100000, flexDirection: "column", justifyContent: "center", height: "300px", width: "100%" }}>
                <Box sx={{ display: 'flex', position: "absolute", justifyContent: "center", width: "100%" }}>
                  <CircularProgress />
                </Box>
              </Box>}
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  )
}